import { getAuthAxiosBackend } from "@/helpers/axios"
import { SacrificerServices } from "@/services/sacrificerServices"

class DeceasedServices extends SacrificerServices{    

    getProfileDataByPersonId(id){
        return getAuthAxiosBackend().get('PersonProfile/deadProfile/' + id.toString())
    }
}

export default new DeceasedServices()